

/// <reference path="DBDocument.ts" />

// Generated class QuotationDocument_ManagedObject

class QuotationDocument_ManagedObject extends DBDocument
{
    // Relationship: contact
    set contact(value:Contact) {
        this.setValueForKey(value, 'contact');
    }
    get contact():Contact {
        return this.valueForKey('contact') as Contact;
    }
}
